/**
 * Created by jiachenpan on 16/11/18.
 */

export function isvalidUsername(str) {
  const valid_map = ["admin", "editor"];
  return valid_map.indexOf(str.trim()) >= 0;
}

// 正则按A-Z排序通讯录（中文、英文、特殊字符）
export function pySegSor(arr) {
  if (arr.length == 0) return;
  if (!String.prototype.localeCompare) return null;
  var letters = "*ABCDEFGHJKLMNOPQRSTWXYZ".split("");
  var zh = "阿八嚓哒妸发旮哈讥咔垃痳拏噢妑七呥扨它穵夕丫帀".split("");
  var segs = []; // 存放数据
  var res = {};
  let curr;
  var re = /[^\u4e00-\u9fa5]/; //中文正则
  var pattern = new RegExp(
    "[`\\-~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？12345678990]"
  ); //特殊符号

  letters.filter((items, i) => {
    curr = {
      initial: "", //字母
      data: [] //数据
    };
    arr.map((v, index) => {
      // 特殊字符
      if (pattern.test(v.name[0])) {
        if (
          (!zh[i - 1] || zh[i - 1].localeCompare(v.name) <= 0) &&
          v.name.localeCompare(zh[i]) == -1
        ) {
          curr.data.push(v);
        }
      }
      // 判断首个字是否是中文
      if (re.test(v.name[0])) {
        // 英文
        if (v.name[0].toUpperCase() == items) {
          curr.data.push(v);
        }
      } else {
        // 中文
        if (
          (!zh[i - 1] || zh[i - 1].localeCompare(v.name) <= 0) &&
          v.name.localeCompare(zh[i]) == -1
        ) {
          curr.data.push(v);
        }
      }
    });

    if (curr.data.length) {
      curr.initial = letters[i];
      segs.push(curr);
      curr.data.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    }
  });
  res.segs = Array.from(new Set(segs)); //去重

  return res;
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母*/
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}
/**
 * 判断是否为空
 */
export function validatenull(val) {
  if (typeof val === "boolean") {
    return false;
  }
  if (val instanceof Array) {
    if (val.length === 0) return true;
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === "{}") return true;
  } else {
    if (
      val === "null" ||
      val == null ||
      val === "undefined" ||
      val === undefined ||
      val === ""
    )
      return true;
    return false;
  }
  return false;
}

/**
 * 判断手机号码是否正确
 */
export function isvalidatemobile(phone) {
  const list = [];
  let result = true;
  let msg = "";
  var isPhone = /^0\d{2,3}-?\d{7,8}$/;
  // 增加134 减少|1349[0-9]{7}，增加181,增加145，增加17[678]
  // const isMob = /^((\+?86)|(\(\+86\)))?(13[0123456789][0-9]{8}|15[012356789][0-9]{8}|18[012356789][0-9]{8}|14[57][0-9]{8}|17[3678][0-9]{8})$/
  if (!validatenull(phone)) {
    if (phone.length === 11) {
      if (isPhone.test(phone)) {
        msg = "手机号码格式不正确";
      } else {
        result = false;
      }
    } else {
      msg = "手机号码长度不为11位";
    }
  } else {
    msg = "手机号码不能为空";
  }
  list.push(result);
  list.push(msg);
  return list;
}

// 禁止输入数字以及特殊符号
export function special(e) {
  const filtera = new RegExp(
    /[-]|[`~!@#$%^&*()\+=<>?"{}|,\/;'\\[\]·~！@#￥%……&*（） ——_ \+={}|《》？：“”【】、；‘’，。、]$/
  );
  const data = filtera.test(e);
  return data;
}

// 禁止输入特殊符号
export function domain(e) {
  const text = new RegExp(
    /[`~!@#$%^&*()\+=<>?"{}|,\/;'\\[\]·~！@#￥%……&*（） ——_\+={}|《》？：“”【】、；‘’，。、]$/
  );
  const data = text.test(e);
  return data;
}

// 只能输入英文、汉字、以及英文.
export function allowEnter(e) {
  // const text = new RegExp(/^.[a-zA-Z\u4e00-\u9fa5.]+$/)
  const text = new RegExp(/^[\u4e00-\u9fa5A-Za-z.]+$/);
  const data = text.test(e);
  return data;
}
// 只能输入英文、数字、以及——.
export function allow(e) {
  // const text = new RegExp(/^.[a-zA-Z\u4e00-\u9fa5.]+$/)
  let add = e.replace(/[^A-Za-z0-9\\W_]+$/g, "");
  return add;
}

// 只能输入英文、汉字、数字
export function allowNumEnter(e) {
  const text = new RegExp(
    /[^a-zA-Z0-9\u4E00-\u9FA5 `~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g
  );
  const data = text.test(e);
  return data;
}

// 禁止输入表情
export function banExpressions(newValue) {
  newValue = newValue.replace(
    /[^a-zA-Z0-9\u4E00-\u9FA5 `~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g,
    ""
  );
  return newValue;
}

// 手机号中间四位****
export function phoneNumFilter(phoneNum) {
  let str = String(phoneNum),
    strLen = str.slice(-8, -4);
  return str.replace(strLen, "****");
}

// 资源url 自动补全
export function changResourceUrl(e) {
  var http = e.includes("http://");
  var https = e.includes("https://");
  if (http && https) {
    return e;
  } else {
    var url = window.g.BASE_API + e;
    return url;
  }
}
// 过滤特殊字符只保留数字 实现只能输入数字现在 （整数）
export function filterNUmber(val) {
  if (!val) {
    return add;
  }
  let add = val.replace(/[^0-9]/gi, "");
  return add;
}
// 过滤特殊字符只保留数字 实现只能输入数字（整数）
export function filterNUmberOne(val) {
  if (!val) {
    return add;
  }
  let add = val.toString().replace(/[^1-9]/gi, "");
  return add;
}
// 手机号处理
export function telfilter(val) {
  let phoneInt = /^\d+$/;
  // console.log(this.amendphone)
  // 过滤特殊字符保留数字
  let tel = filterNUmber(val);
  if (phoneInt.test(tel) == false) {
    tel = "";
  }
  return tel;
}
//json去重方法
export function repeatNo(jsonSJ) {
  //判断数据的长度
  let arrylist = [];
  if (jsonSJ.length > 0) {
    Array.prototype.removeRepeat = function() {
      var res = [this[0]];
      for (var i = 1; i < this.length; i++) {
        var repeat = false;
        for (var j = 0; j < res.length; j++) {
          if (this[i].id == res[j].id) {
            repeat = true;
          }
        }
        if (!repeat) {
          res.push(this[i]);
        }
      }
      return res;
    };
    arrylist = jsonSJ.removeRepeat();
    // console.log(jsonSJ.removeRepeat()) //去重之后的数据
  }
  return arrylist;
}

// 数组去重 返回不同的值
export function diffent(arr1, arr2) {
  const _arr1 = arr1.filter(item1 => !arr2.includes(item1));
  const _arr2 = arr2.filter(item2 => !arr1.includes(item2));

  const _arr = _arr1.concat(_arr2);
  return _arr;
}

// 单个数组中 只保留不重复的元素 去除所有重复
export function solution(arr) {
  let oneArr = [...new Set(arr)];
  let countArr = Array(oneArr.length);
  let resArr = [];
  countArr.fill(0);
  for (let i of arr) {
    for (let j in oneArr) {
      if (i === oneArr[j]) {
        countArr[j]++;
      }
    }
  }

  for (let i in countArr) {
    if (countArr[i] === 1) {
      resArr.push(oneArr[i]);
    }
  }
  return resArr;
}

//手机脱敏
export function dataDesensitization(num) {
  var len = num.length;
  if (len && len > 4) {
    return num.substring(0, 3) + "****" + num.substring(len - 4, len);
  } else {
    return "";
  }
}

// mac地址
export function checkMac(val) {
  //mac地址正则表达式
  var reg_name = /[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}/;
  if (!reg_name.test(val)) {
    return false;
  }
  return true;
}

// ip地址
export function checkIp(val) {
  var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  if (!reg.test(val)) {
    return false;
  }
  return true;
}

// 阿拉伯数字转中文数字
export function changeNumToHan(num) {
  let arr1 = new Array(
    "零",
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九"
  );
  let arr2 = new Array(
    "",
    "十",
    "百",
    "千",
    "万",
    "十",
    "百",
    "千",
    "亿",
    "十",
    "百",
    "千",
    "万",
    "十",
    "百",
    "千",
    "亿"
  ); //可继续追加更高位转换值
  if (!num || isNaN(num)) {
    return "零";
  }
  let english = num.toString().split("");
  let result = "";
  for (let i = 0; i < english.length; i++) {
    let des_i = english.length - 1 - i; //倒序排列设值
    result = arr2[i] + result;
    let arr1_index = english[des_i];
    result = arr1[arr1_index] + result;
  }
  //将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零(千|百|十)/g, "零").replace(/十零/g, "十");
  //合并中间多个零为一个零
  result = result.replace(/零+/g, "零");
  //将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/零亿/g, "亿").replace(/零万/g, "万");
  //将【亿万】换成【亿】
  result = result.replace(/亿万/g, "亿");
  //移除末尾的零
  result = result.replace(/零+$/, "");
  //将【零一十】换成【零十】
  //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
  //将【一十】换成【十】
  result = result.replace(/^一十/g, "十");
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/validate.js